import React, { FC, useEffect, useState } from 'react';
import { BUTTON_TYPE, ButtonComponent } from '../ButtonComponent';
import { ActionName } from '../../interfaces/links';
import { faCirclePlus } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import axios from 'axios';
import { BASE_URL } from '../../../config/environmentConfig';
import { ModalWindow } from '../modal/ModalWindow';

export enum PlatformProvider {
	Stripe = 'Stripe',
}

export interface IPlatformActions {
	actionName: ActionName;
	actionIcon?: React.ReactNode;
}

export interface IPlatformConnectOptions {
	actionName: ActionName;
	actionIcon?: React.ReactNode;
	title: string;
	description: string;
}

export interface IPlatform {
	provider: PlatformProvider;
	description: string;
	onConnectButtonClick: () => void;
	onDisconnectClick: () => void;
	logo: React.ReactNode;
	actions: IPlatformActions[];
	buttons: React.ReactNode[];
	connectOptions: IPlatformConnectOptions;
	readUrl?: string;
}

export const PlatformItem: FC<IPlatform> = (props) => {
	const { provider, onConnectButtonClick, onDisconnectClick, description, buttons, connectOptions, readUrl, logo, actions } = props;

	const [isLoading, setIsLoading] = useState(true);
	const [status, setStatus] = useState('');
	const [isModalOpen, setIsModalOpen] = useState(false);

	useEffect(() => {
		axios.get(`${BASE_URL.API_CLIENT}/ProvidersOAuth/provider-connection-status?provider=${provider}`)
			.then(res => {
				setStatus(res.data.status);
				setIsLoading(false);
			})
			.catch(err => {
				setStatus('Disconnected');
				setIsLoading(false);
			});
	}, []);

	return (
		<div className="card-body platform-item xs=8">
			<div className="d-flex justify-content-between align-items-center mb-3">
				<div className="d-flex align-items-center">
					{logo}
					<div className="provider-item-title ms-2">
						{provider}
					</div>
				</div>
				<div>
					{/*<button className="btn btn-link" onConnectButtonClick={onConnectButtonClick}>Actions</button>*/}
				</div>
			</div>
			<div className="provider-item-description mb-3">
				{description}
			</div>
			<div className="d-flex align-items-center justify-content-between">
				{
					status === 'Connected' ?
						<ButtonComponent
							buttonType={BUTTON_TYPE.WHITE_SUCCESS}
							onButtonClick={(): void => setIsModalOpen(true)}
							additionalClass="no-letter-spacing fs-7 py-1 ps-2 pe-3 d-block"
						>
							<>
								Disconnect
							</>
						</ButtonComponent>:
						<ButtonComponent
							buttonType={BUTTON_TYPE.WHITE}
							onButtonClick={onConnectButtonClick}
							additionalClass="no-letter-spacing fs-7 py-1 ps-2 pe-3 d-block"
							loading={isLoading}
							isDisabled={isLoading}
						>
							<>
								<FontAwesomeIcon icon={faCirclePlus} className="h-15px"/> Connect
							</>
						</ButtonComponent>
				}

				{/*<button onConnectButtonClick={onConnectButtonClick}>Connect</button>*/}
				{/*<a href="https://example.com" target="_blank" rel="noopener noreferrer">Read more</a>*/}
			</div>

			<ModalWindow
				isOpen={isModalOpen}
				modalTitle={'Are you sure you want to disconnect Stripe?'}
				confirmButtonText={'Confirm'}
				onClose={(): void => setIsModalOpen(false)}
				onCancel={(): void => {
					onDisconnectClick();
					setIsModalOpen(false);
				}}
				onConfirm={(): void => {
					onDisconnectClick();
					setIsModalOpen(false);
				}}
				contentClassName="position-relative"
				content={
					<div className="px-8 pt-5">
						<div className="fs-5 mb-10">
							You will be redirected to your Stripe dashboard. If you&#39;re not logged in, you&#39;ll be asked to
							enter your credentials.
						</div>

						<div className="fs-5 mb-10">
							To complete the disconnection, go to App Settings in Stripe and click Uninstall.
						</div>

						<div className="fs-5">
							Once uninstalled, Stripe will stop sending transactions to FlexFactor.
						</div>
					</div>
				}
			/>
		</div>
	);
};
